/**
 * Route-level code splitting helpers (#3452).
 *
 * `React.lazy` only accepts a module with a default export; most feature
 * pages are named exports. `lazyNamed` adapts one named export so a route can
 * be split without touching the feature's public API.
 *
 * Chunk-load failure (dead connection after iOS backgrounding, a deploy
 * between page load and navigation) surfaces as Vite's `vite:preloadError`,
 * handled once with a guarded reload in main.tsx; past that budget the
 * rejection reaches AppErrorBoundary's recoverable screen. Nothing to add
 * here.
 */
import { lazy, type ComponentType, type LazyExoticComponent } from 'react';

export function lazyNamed<
  K extends string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  M extends Record<K, ComponentType<any>>,
>(loader: () => Promise<M>, name: K): LazyExoticComponent<M[K]> {
  return lazy(async () => {
    const mod = await loader();
    return { default: mod[name] };
  });
}
